import * as Sentry from '@sentry/react';

/**
 * La traccia di quando la damiera e la verita' del server si separano.
 *
 * Questo difetto — mossa dell'avversario che non compare, orologio proprio che
 * continua a scorrere — e' arrivato da una segnalazione a voce e non ha lasciato
 * NIENTE dietro di se': il `log.warn` degli scarti e' un no-op fuori dallo
 * sviluppo (`utils/logger.ts`), quindi in produzione gli aggiornamenti buttati
 * non esistevano. Qui si mette il minimo perche' la prossima volta ci sia
 * qualcosa da leggere.
 *
 * Due livelli, con criteri diversi:
 *
 *  - `breadcrumbDesync` per i fatti FREQUENTI (un aggiornamento scartato perche'
 *    non e' di questa damiera): niente eventi, solo la scia che accompagna il
 *    primo errore vero che dovesse capitare.
 *  - `segnalaDesync` per i fatti RARI, cioe' le riparazioni: se il client ha
 *    dovuto rimettersi in pari da solo, qualcosa si era rotto e vale un evento.
 */

type DatiDiagnosi = Record<string, unknown>;

export function breadcrumbDesync(evento: string, dati?: DatiDiagnosi): void {
  Sentry.addBreadcrumb({
    category: 'sincronia-partita',
    message: evento,
    level: 'info',
    data: dati,
  });
}

export function segnalaDesync(evento: string, dati?: DatiDiagnosi): void {
  breadcrumbDesync(evento, dati);
  Sentry.captureMessage(`sincronia-partita: ${evento}`, {
    level: 'warning',
    tags: { area: 'sincronia-partita', evento },
    extra: dati,
  });
}
